import React from 'react';
import styled from 'styled-components';
import { StyledButton as Button } from '../../CommonComponents/Button';
import Input from '../../CommonComponents/Input';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  background: #fff;
  padding: ${props => (props.withSearchBar ? '15px' : '25px 35px')};
  border-bottom: 1px solid rgba(151, 151, 151, 0.15);
  margin: 0;
`;

const SearchInput = styled(Input).attrs({
  appearance: 'rounded',
  size: 'small',
  prependIcon: 'fa fa-search',
})`
  width: calc(100% - 70px);

  ${Input.StyledInput}:focus ~ ${Input.PrependedIcon} {
    color: #4d92e2;
  }

  ${Input.PrependedIcon} {
    color: #d9d7d7;
  }
`;

const NavbarLinkButton = styled(Button).attrs({
  appearance: 'link',
})`
  color: #0078D4;
`;

const MobileSearch = ({ onSearchDoneClick, query, onQueryChange }) => (
  <Wrapper withSearchBar>
    <SearchInput
      placeholder="Search"
      value={query}
      onChange={({ target: { value } }) => onQueryChange(value)}
      onForwardedRef={(input) => {
        if (input) {
          input.focus();
          input.scrollIntoViewIfNeeded();
        }
      }}
    />

    <NavbarLinkButton onClick={onSearchDoneClick}>Done</NavbarLinkButton>
  </Wrapper>
);

export default MobileSearch;
